import { createQueryKeys } from '@lukemorales/query-key-factory';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getAccessToken, logout } from '@repo/auth';
import { axios } from '@repo/http';
import { del_profile_settings_deactivate_path } from 'ze-api-contract/user-v2/profile-settings/deactivate-user';
import { GET_PROFILE_SETTINGS, get_profile_settings_path } from 'ze-api-contract/user-v2/profile-settings/get-profile';
import { post_profile_settings_path } from 'ze-api-contract/user-v2/profile-settings/update-profile';
import { currentUser } from './current-user';
export const publicProfileSettingsQuery = createQueryKeys('public-profile-settings', {
    getPublicProfileSettings: ()=>({
            queryKey: [
                GET_PROFILE_SETTINGS
            ],
            queryFn: async ()=>{
                return axios.get(get_profile_settings_path()).then((res)=>res.data.value);
            }
        })
});
export function useUpdateSettings() {
    const queryClient = useQueryClient();
    const { queryKey } = publicProfileSettingsQuery.getPublicProfileSettings();
    const token = getAccessToken();
    const { queryKey: currentUserQueryKey } = currentUser.current(token);
    return useMutation({
        mutationFn: (data)=>axios.post(post_profile_settings_path(), data),
        onSuccess: async ()=>{
            await queryClient.invalidateQueries({
                queryKey
            });
            await queryClient.invalidateQueries({
                queryKey: currentUserQueryKey
            });
        }
    });
}
export function useRemoveProfile() {
    const queryClient = useQueryClient();
    const { queryKey } = publicProfileSettingsQuery.getPublicProfileSettings();
    return useMutation({
        mutationFn: ()=>axios.delete(del_profile_settings_deactivate_path()),
        onSuccess: async ()=>{
            await queryClient.invalidateQueries({
                queryKey
            });
            await logout(queryClient);
        }
    });
}
export function usePublicProfileSettings() {
    const { isLoading, data: settings, error } = useQuery(publicProfileSettingsQuery.getPublicProfileSettings());
    return {
        settings,
        isLoading,
        error
    };
}
